export const KNOWN_PSAP_IDS = {
  emsCzLk: 'c3860bca-0f51-441d-a1a6-682c39b3088d',
} as const;
